module.exports = __webpack_public_path__ + "static/img/planning2.64ae025a.png";